import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { contact } from 'contact/model/contact.fragments';
import { jobOffer } from 'job/model/job-offer.fragments';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { tasksParticipant } from '../model/task.fragments';
import { TaskOutput } from '../model/task.output';

export interface MarkTaskPendingParams {
	readonly id: string;
}

@Injectable({ providedIn: 'root' })
export class MarkTaskPendingApiMutation extends ApiMutation<
	TaskOutput,
	MarkTaskPendingParams
> {
	client = 'iam';
	document = gql`
		mutation MarkTaskPending($id: UUID!) {
			markTaskPending(id: $id) {
				id
				done
				type
				owner {
					id
				}
				contact {
					...Contact
				}
				jobOffer {
					...JobOffer
				}
				modulesId
				todoTitle
				dueTimestamp
				updateTimestamp
				participants {
					...TasksParticipant
				}
				todoDescription
				externalEventTitle
				externalEventId
			}
		}
		${tasksParticipant}
		${jobOffer}
		${contact}
	`;
	method = 'markTaskPending';
}
